import axios from "axios";

export function getJobList() {
  return axios.get(process.env.VUE_APP_API_URL + "Job/getlist");
}

export function postJob(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Job/add", data);
}

export function updateJob(data) {
  return axios.put(process.env.VUE_APP_API_URL + "Job/update", data);
}

export function deleteJob(jobId) {
  const config = {
    params: {
      jobId: jobId,
    },
  };

  return axios.delete(process.env.VUE_APP_API_URL + "Job/deleted", config);
}
